var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0.Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.136,
    height: 22.136,
    viewBox: "0 0 22.136 22.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M52.606,50.436V42.328c0-3.985-.858-7.028-5.506-7.028a4.8,4.8,0,0,0-4.344,2.38H42.7V35.66H38.3V50.436h4.593V43.1c0-1.937.36-3.791,2.739-3.791,2.352,0,2.38,2.186,2.38,3.9v7.194h4.593Z",
    transform: "translate(-30.469 -28.299)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M11.3,36.6h4.593V51.376H11.3Z",
    transform: "translate(-10.94 -29.24)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M12.656,10a2.67,2.67,0,1,0,2.656,2.656A2.657,2.657,0,0,0,12.656,10Z",
    transform: "translate(-10 -10)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.263df23c74286d2ff66e33b7827c0523.svg";
export { ForwardRef as ReactComponent };